import { render, staticRenderFns } from "./FactLabel.vue?vue&type=template&id=ec750f84&scoped=true&"
import script from "./FactLabel.vue?vue&type=script&lang=ts&"
export * from "./FactLabel.vue?vue&type=script&lang=ts&"
import style0 from "./FactLabel.vue?vue&type=style&index=0&id=ec750f84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec750f84",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VLayout})
